/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { SystemEntity } from '../models/system-entity';

/**
 * DTO for a Reference object
 */
export interface Reference {

  /**
   * ID
   */
  id: string;

  /**
   * Name
   */
  name?: string | null;
  type?: SystemEntity;
}

export class Reference {
  id: string;
  name?: string | null;
  type?: SystemEntity;

  constructor(value: Reference) {
    this.id = value.id;
    this.name = value?.name;
    this.type = value?.type ? Object.entries(Object.values(SystemEntity)).flatMap((x) => x).find(x => x === value.type) as SystemEntity : undefined;
  }
}
